export default {"src":"/_next/static/media/download-zoom-illustration.9288bb93.svg","height":225,"width":343,"blurWidth":0,"blurHeight":0};